import { API_SERVICE } from "./root";
//  导入pb文件
//  系统配置参数proto
import { ConfigClient } from "@/pbjs/external/config/config_grpc_web_pb";
//  命名请求对象
const configClient: any = new ConfigClient(API_SERVICE, null, null);

export { configClient };
